import React, { createContext, FC, ReactNode, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { getUserProfile, getConfigDetails } from '../services/common.service';
import { toasts } from '../services/toaste.service';

export interface IAuthContextProps {
	userAccountId: any;
	userData: any;
	userTypeId: any;
	previousVideo: any;
	configData: any;
	setUserAccountId?(...args: unknown[]): unknown;
	setUserData?(...args: unknown[]): unknown;
	setUserTypeId?(...args: unknown[]): unknown;
	setPreviousVideo?(...args: unknown[]): unknown;
	setConfigData?(...args: unknown[]): unknown;
}
const AuthContext = createContext<IAuthContextProps>({} as IAuthContextProps);

interface IAuthContextProviderProps {
	children: ReactNode;
}
export const AuthContextProvider: FC<IAuthContextProviderProps> = ({ children }) => {
	const [userAccountId, setUserAccountId] = useState<string>(localStorage.getItem('userAccountId') || '');
	const [userTypeId, setUserTypeId] = useState<string>(localStorage.getItem('userTypeId') || '');
	const [previousVideo, setPreviousVideo] = useState(localStorage.getItem('videoName') || '0')
	const [userData, setUserData] = useState<any>({});
	const [configData, setConfigData] = useState<any>(() => {
		const savedConfig = localStorage.getItem('configData');
		try {
			return savedConfig ? JSON.parse(savedConfig) : [];
		} catch (e) {
			return [];
		}
	});

	useEffect(() => {
		localStorage.setItem('userAccountId', userAccountId);
		localStorage.setItem('videoName', previousVideo);
		localStorage.setItem('configData', JSON.stringify(configData));
	}, [userAccountId, previousVideo, configData]);

	useEffect(() => {
		if (userAccountId !== '') {
			getStudentProfile(userAccountId);
		}
	}, [userAccountId]);

	useEffect(() => {
		getConfig();
	}, []);

	function getConfig() {
		getConfigDetails(
			(response) => {
				if (response.data.success) {
					let data = response.data.data.configDetails;
					if (data != undefined) {
						setConfigData(data);
					}
				}
			}, error => {
				console.error(error);
			}
		)
	}

	function getStudentProfile(studentDetailsId: any) {
		getUserProfile(studentDetailsId,
			(response) => {
				if (response.data.success) {
					let data = response.data.data.userProfile[0];
					if (data != undefined) {
						setUserData(data);
					} else {
						toasts("Undefined Data", "Error")
					}
				}
				else if (response.data.success === false) {
					toasts(response.data.message, "Error")
				} else {
					let errorCode = response.data.error[0].error_code;
					let errorDescription = response.data.error[0].error_description;
					toasts(errorDescription, "Error")
				}
			}, error => {
				toasts(error, "Error")
			}
		)
	}

	const value = useMemo(
		() => ({
			userAccountId,
			setUserAccountId,
			userData,
			userTypeId,
			setUserTypeId,
			setPreviousVideo,
			previousVideo,
			configData,
			setConfigData
		}),
		[userAccountId, userTypeId, previousVideo, userData, configData],
	);
	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
AuthContextProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export default AuthContext;